module.exports = __webpack_public_path__ + "img/finish-clock.8757a7bf.svg";